const TAC = () => {
    return(
            <div>
            <h1>Terms and Conditions</h1>
            <p>
                By using the illustrator, you agree you have read and understood the Terms and Conditions set out below.
            </p>
            <h2>1. Use of this illustrator</h2>
            <p>
                The illustrator is solely for guidance purposes and provides estimates only. It is not intended to provide financial advice. If you require financial advice, you should contact an independent financial adviser. The Government Actuary’s Department (GAD) and Civil Service Pensions (NI) and its administrators do not accept any liability for financial decisions taken based on the information provided in this illustrator.
            </p>
            <p>
                The results shown are an indication of the benefits you may receive; they are not guaranteed, and you should not enter into financial commitments on the basis of the information provided.
            </p>
            <p>
                The illustrator does not override the scheme rules or pension legislation.
            </p>
            <p>
                This illustrator only applies for members of the Northern Ireland Civil Service Pension Scheme. This illustrator does not provide illustrations for members in the Nuvos scheme.
            </p>
            
            <h2>2. How your pension and lump sum have been estimated</h2>
            
            <h3>2.1. Choice of benefits accrued over 1 April 2015 to 31 March 2022</h3>
            <p>
                The results sections are based on members choosing to receive legacy scheme or alpha scheme benefits for the Remedy Period, 1 April 2015 to 31 March 2022. Financial advice may be sought before making your choice.
            </p>
            <p>
                Member contributions have not been included in the illustrations. Since April 2015, member contribution rates have been the same regardless of which scheme a member was contributing toward. Therefore, the vast majority of members would have paid the same amount of contributions whether they were participating in their legacy scheme or the alpha scheme. There are a very small number of exceptions to this, who will have their contributions corrected when they receive their Remediable Service Statement (RSS).
            </p>
            
            <h3>2.2. Assumptions</h3>
            <p>
                The pension and lump sum estimates are based on the following key assumptions:
            </p>
            <ul>
                <li>Future Consumer Price Index (CPI) inflation is assumed to be 2% pa.</li>
                <li>Future Pensions in payment are assumed to increase in line with CPI, i.e. at a rate of 2% pa.</li>
                <li>Your total alpha pension is adjusted in line with prices every year that you are an active member of the alpha scheme. Actual CARE revaluation rates are used up to the latest available rate. Thereafter, future increases are assumed to occur at a rate of 2% pa.</li>
                <li>Users can set their own future salary increases between -2% and 3% p.a. in excess of inflation. For future salary increases, in nominal terms, this would be 0% and 5% p.a. (i.e. after allowing for 2% assumed future CPI inflation).</li> 
                <li>If users do not enter a salary as at 1 April 2015 salaries between 2015 and current date are estimated using high level historical salary increase assumptions.</li>
                <li>Salary increases do not allow for any future promotional salary increases you may receive.</li>
                <li>It is assumed that you will retire on normal terms (i.e. you are not retiring in ill-health).</li>
            </ul>
            <p>
                The estimates use a simplified approach to calculating pensionable earnings (and salary of reference), in particular:
            </p>
            <ul>
                <li>Your legacy scheme benefits at partial and full retirement have been estimated based on the projected pensionable earnings at those points. This ignores the more complex rules determining final pensionable earnings that take account of higher salaries in earlier periods. Therefore, if you reduce your full-time equivalent salary at partial retirement or have previously experienced a reduction in full-time equivalent salary, this illustrator may understate the pension payable at full retirement.</li>
                <br></br>
                <li>Similarly, salary of reference for the purpose of abatement is calculated using the salary projected to partial retirement date without looking back to periods at previous dates. This means that if a member’s salary or part-time hours have reduced <strong>before</strong> partial retirement, in this illustrator the salary of reference could be understated (and so the impact of abatement overstated).</li>
            </ul>
            
            <h3>2.3. Adjustments for early or late payment of pension</h3>
            <p>
                The amount of pension you receive depends on when you retire.
            </p>
            <p>
                This illustrator applies adjustments when pension and lump sum are taken earlier or later than the relevant scheme’s Normal Pension Age, in line with the scheme rules. Early retirement may result in a reduction in pension benefits to account for the fact that the benefits will be paid over a longer period of time.
            </p>
            <p>
                The early and late retirement adjustment factors referred to are those currently in effect. However, they will be reviewed periodically, and may increase or decrease. Your benefits at retirement will depend on any adjustment factors in effect at that time.
            </p>
            
            <h3>2.4. Cash lump sum</h3>
            <p>
                At retirement, you will get an automatic lump sum from service in the Classic and Classic Plus schemes. This is usually three times your pension  (only of pre-30 September 2002 pension for Classic Plus members). The illustrator assumes this is the case for the purpose of the projections; where a member’s automatic lump sum is not based on three times, the illustrator will be less accurate (though may still be useful).   
            </p>
            <p>
            You are eligible to commute pension (exchange pension for a one-off lump sum) from all of the Northern Ireland Civil Service Pension Schemes. You can vary the levels of commutation using the ‘Equalise Lump Sums’ toggle, and the commutation toggles below the graphs in the ‘Results’.
            </p>
            
            <h2>3. Taxation</h2>
            <p>
                The illustrations do not allow for taxation. Your benefits will be subject to the various tax rates and limits in force.
            </p>
            
            <h2>4. Other</h2>
            <p>
                The results do not include any money purchase Additional Voluntary Contributions (AVCs) or Added Pension benefits which you may have purchased, pension debits, WPS contributions or other special arrangements within the scheme. Members who may be entitled to a WPS refund will have their eligibility confirmed at full retirement. If you have these, or similar additional options, the illustrator will be less accurate (though it may still be helpful).
            </p>
            <p>
                The illustrator does not show pension from other sources, for example the state pension or other private pensions you may have.
            </p>
            <p>
                Your scheme provides survivor benefits payable in the event of your death, which are not shown here. See your scheme guide for details. Your benefit statement may also include more about this.
            </p>
            <p>
                No allowance has been made for guaranteed minimum pension (GMP) and any impact that GMP has on when you can take your pension benefits.
            </p>
                        <p>
                The Department of Finance Accessibility Statement is available at:{" "}  
                <a href="https://www.finance-ni.gov.uk/articles/accessibility-statement-finance"
                 target="_blank"
                 rel="noopener noreferrer">
                 https://www.finance-ni.gov.uk/articles/accessibility-statement-finance 
                 </a>. 
            </p>{" "}
            <p>
                Should you require{" "} 
                 <a href="https://www.gov.uk/service-manual/helping-people-to-use-your-service/assisted-digital-support-introduction"
                    target="blank"
                    rel="noopener noreferrer">
                    assisted digital support{" "} 
                 </a> 
                  to help you use this calculator or need the outputs in an alternative format please{" "} 
                 <a href="https://www.finance-ni.gov.uk/contacts/contact-civil-service-pensions-ni"
                 target="blank"
                 rel="noopener noreferrer">
                    contact us
                 </a>.
            </p>{" "}
            </div>
    )
}

export default TAC

